import { ReactNode } from 'react';
import { ProgressSpinner } from 'primereact/progressspinner';
import { useUserStore } from '@/stores/user';
import NotFound from '@/pages/NotFound';

interface SuperuserRouteProps {
  children: ReactNode;
}

function SuperuserRoute({ children }: SuperuserRouteProps) {
  const isAuthenticated = useUserStore((s) => s.isAuthenticated);
  const isSuperuser = useUserStore((s) => s.isSuperuser);
  const hydrated = useUserStore((s) => s.hydrated);

  if (!hydrated) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: 'calc(100dvh - 65px)'
        }}
      >
        <ProgressSpinner />
      </div>
    );
  }

  // Stealth 404: if not superuser, render NotFound page directly without redirecting
  if (!isAuthenticated || !isSuperuser) {
    return <NotFound />;
  }

  return <>{children}</>;
}

export default SuperuserRoute;
